var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-page',[_c('div',{staticClass:"settings"},[_c('PanelMenu',{attrs:{"model":_vm.links}}),(_vm.isVisible)?_c(_vm.currentSubPage.component,{tag:"component"}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }